var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5001 0C5.61481 0 0 5.60346 0 12.5C0 19.3852 5.60347 25 12.5001 25C19.3853 25 25.0001 19.3966 25.0001 12.5C25.0001 5.60346 19.3966 0 12.5001 0ZM12.5001 1.84892C18.3871 1.84892 23.1398 6.60163 23.1398 12.4887C23.1398 18.3757 18.3871 23.1284 12.5001 23.1284C6.613 23.1284 1.86026 18.3757 1.86026 12.4887C1.86026 6.60163 6.613 1.84892 12.5001 1.84892ZM12.4093 4.60526C11.9329 4.66198 11.5699 5.07033 11.5813 5.54673V12.4887C11.5813 12.8289 11.7628 13.1352 12.0577 13.294L16.2206 15.608C16.663 15.8575 17.2301 15.6987 17.4797 15.245C17.7292 14.8026 17.5704 14.2355 17.1167 13.9859L13.4302 11.9329V5.5354C13.4415 5.02496 13.0332 4.60527 12.5227 4.59392H12.4887C12.466 4.60527 12.432 4.60526 12.4093 4.60526Z",
    fill: "#0E3368"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.4dda88a9.svg";
export { ForwardRef as ReactComponent };